import { createContext, useContext, useState, useEffect, useRef } from "react";
import { PropTypes } from "prop-types";
import { Auth } from "aws-amplify";
import { onAuthUIStateChange, AuthState } from "@aws-amplify/ui-components";

const authContext = createContext();

const useProvideAuth = () => {
  const [authState, setAuthState] = useState();
  const [user, setUser] = useState();
  const userGroups = useRef([]);

  const setSignedOut = () => {
    userGroups.current = null;
    setUser();
    setAuthState(AuthState.SignedOut);
  };

  const setSignedIn = (userData) => {
    userGroups.current =
      userData.signInUserSession.accessToken.payload["cognito:groups"];
    setUser(userData);
    setAuthState(AuthState.SignedIn);
  };

  useEffect(() => {
    const setCurrentAuthenticatedUser = async () => {
      try {
        const currentUser = await Auth.currentAuthenticatedUser();
        if (currentUser) {
          setSignedIn(currentUser);
        } else {
          setSignedOut();
        }
      } catch (e) {
        setSignedOut();
      }
    };

    setCurrentAuthenticatedUser();

    return onAuthUIStateChange((nextAuthState, authData) => {
      if (nextAuthState === AuthState.SignedIn && authData) {
        setSignedIn(authData);
      } else {
        userGroups.current = null;
        setAuthState(nextAuthState);
        setUser();
      }
    });
  }, []);

  return {
    authState,
    user,
    userGroups,
  };
};

export const ProvideAuth = ({ children }) => {
  const auth = useProvideAuth();
  return <authContext.Provider value={auth}>{children}</authContext.Provider>;
};

ProvideAuth.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useAuth = () => useContext(authContext);
